import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-custompopupselect',
  templateUrl: './custompopupselect.component.html',
  styleUrls: ['./custompopupselect.component.scss']
})
export class CustompopupselectComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  public dialogRef: MatDialogRef<CustompopupselectComponent>,) { }
  heading = 'Select Items';
  searchitem = '';
  isMultiple = false; // Toggle between single and multiple selection
  selectedItems: any[] = []; // Holds selected items
  itemlistArray :any= [
  
  ]; 
  updatedlistArray:any = [
  
  ]; 

  ngOnInit(){
    this.itemlistArray=this.data.itemlist
    this.heading=this.data.heading
    this.isMultiple=this.data.ismultiple
    console.log( this.itemlistArray);
    // this.updatedlistArray = this.itemlistArray.map((item:any) => {
    //   // Destructure the original object excluding 'vehiclename'
    //   const { vehiclename, ...rest } = item;
    
    //   // Return a new object with 'name' replacing 'vehiclename'
    //   return {
    //     ...rest,
    //     name: vehiclename,
    //   };
    // });
    console.log(  this.updatedlistArray );
    
    
  }
  // Check if an item is selected
  isSelected(item: any): boolean {
    return this.selectedItems.some((selected) => selected.id === item.id);
  }

  // Handle single item selection
  selectItem(item: any) {
    if (!this.isMultiple) {
      this.selectedItems = item;
      this.dialogRef.close(   this.selectedItems)
    }
    else{
      // this.dialogRef.close(this.selectedItems)
    }
  }

  // Toggle multiple item selection
  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex((selected) => selected.id === item.id);
    if (index > -1) {
      // Item already selected: Remove it
      this.selectedItems.splice(index, 1);
    } else {
      // Item not selected: Add it
      this.selectedItems.push(item);
    }
  }

  // Toggle between single and multiple selection modes
  toggleSelectionMode() {
    this.isMultiple = !this.isMultiple;

    // Reset selection when switching to single mode
    if (!this.isMultiple && this.selectedItems.length > 1) {
      this.selectedItems = this.selectedItems.slice(0, 1); // Keep only the first selected item
    }
  }
}